import React, { useState } from 'react'
import {Form, Button} from "react-bootstrap";
import axios from 'axios';
import {useTranslation} from "react-i18next";

function ForgotPassword(){
    const [errorInfo, setErrorInfo] = useState(<div></div>);
    const { t } = useTranslation(['forgot_pass', 'base']);
    const [enabledButton, setEnabledButton] = useState(true);

    function submitForm(event){
        event.preventDefault()
        setEnabledButton(false);

        axios.post('api/user/forgotPassword', { email: event.target[0].value})
            .then(response => {setErrorInfo(<div style={{paddingTop: "10px"}}>{t('success')}</div>); setEnabledButton(true)})
            .catch((error) => {
                console.log(error.response);
                setErrorInfo(<div style={{color: "red", paddingTop: "10px"}}>{t('error')}</div>);
                setEnabledButton(true);
            });
    }

    return(
        <div className='login'>
            <div className='login-container'>
                <div className='console-logo'>{t('forgot_pass')}</div>
                <Form onSubmit={submitForm}>
                <Form.Group className="login-form" controlId={t('address')}>
                    <Form.Label>Адрес</Form.Label>
                    <Form.Control type="email" placeholder={t('address_placeholder')} />
                    <Form.Text className="text-muted">
                    </Form.Text>
                </Form.Group>
                <Button variant="primary" type="submit" disabled={!enabledButton}>
                    {t('submit_button_text')}
                </Button>
                </Form>
                {errorInfo}
            </div>
        </div>
    )
}

export default ForgotPassword;
